import SelectButtons from "../../../ui/select/SelectButtons";
import SelectFilter from "../../../ui/select/SelectFilter";
import SelectSearch from "../../../ui/select/SelectSearch";
import React from "react";
import InformationTabBase from "./tabs/InformationTabBase";
import {Col, Form} from "react-bootstrap";
import InputSearch from "../../../ui/forms/InputSearch";
import StatsAndVideosPerMatchDataTable from "./datatables/StatsAndVideosPerMatchDataTable";
import matchVideoThumbnail from "../../../../assets/img/demo/matchVideoThumbnail.png";
import VideoPlayerModal from "../../../ui/modals/VideoPlayerModal";
import VideosPerMatchModal from "./modals/VideosPerMatchModal";
import {Query} from "@apollo/react-components";
import {fullProfileQueries} from "../../../../store/actions/Dashboard/FullProfile/FullProfileGraphQL";

const row1 = {
    match: {
        team1: {
            name: 'Real Madrid',
            shortName: 'RM',
            goals: 2,
        },
        team2: {
            name: 'Machester United',
            shortName: 'MU',
            goals: 0,
        },
        division: 'Spain premier Division',
        datetime: '12/31/2019 12:00 pm',
    },
    stats: {
        position: 'CF',
        minutes: {
            value: 90,
            total: 90
        },
        goals: {
            value: 0,
            total: 2,
        },
        assists: {
            value: 2,
            total: 10,
        },
        shotsOnTarget: {
            value: 5,
            total: 10,
        },
        penalties: {
            value: 0,
            total: 0,
        },
        shortPasses: {
            value: 20,
            total: 20,
        },
        longPasses: {
            value: 20,
            total: 20,
        },
        crosses: {
            value: 2,
            total: 5,
        },
        dribbles: {
            value: 2,
            total: 3,
        },
        duels: {
            value: 2,
            total: 3,
        },
        arielDuel: {
            value: 2,
            total: 3,
        },
        losses: {
            value: 2,
            total: 3,
        },
        recoveries: {
            value: 2,
            total: 3,
        },
        card: {
            yellow: 0,
            red: 1
        },
    },
    // Reference :https://gist.github.com/jsturgis/3b19447b304616f18657
    videos: {
        fullMatch: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        bestAction: {
            link: 'https://static.videezy.com/system/protected/files/000/000/360/MAH00003.MP4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        teamGoals: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        individualGoals: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        assists: {
            link: '',
            duration: 91,
            thumbnail: null,
        },
        shortPasses: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        longPasses: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        shots: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: null,
        },
        penalties: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
        fouls: {
            link: 'https://static.videezy.com/system/resources/previews/000/019/695/original/pointing-pink.mp4',
            duration: 91,
            thumbnail: matchVideoThumbnail,
        },
    },
};
const initialRows = Array.from(Array(10).keys())
    .map(i => JSON.parse(JSON.stringify(row1))).map((row, index) => {
        return Object.assign({}, {...row, id: index});
    });

class StatsAndVideosPerMatch extends InformationTabBase {
    constructor(props) {
        super(props);

        this.state = {
            type: 'stats',
            showVideoModal: false,
            currentVideo: '',
            currentPlayer: 0,
        };
    }

    /**
     * Renders the content of Stats And Videos Per Match tab.
     * @returns {React.ReactNode} The StatsAndVideosPerMatch tab.
     */
    render = () => {
        return (
            <div className="state-and-videos-per-match-tab">
                {this.renderFilters()}
                {this.renderTable()}
            </div>
        );
    };

    /**
     * Renders the table filters.
     * @returns {*}
     */
    renderFilters = () => {
        // Handler
        const {handleTableSelect} = this;


        const selectButtonsOptions = [
            {value: 'stats', label: 'Stats'},
            {value: 'videos', label: 'Videos'},
        ];

        // TODO Move all full profile filters to global place.
        return (
            <Query query={fullProfileQueries.getCareerStatsFilters}>
                {({data, loading, error}) => {
                    let competitionsOptions = [], seasonsOptions = [], locationsOptions = [];
                    if (!loading && !error) {
                        const withSelectAllOptions = options => [{value: 'all', key: 'all', label: 'Select All'}, ...options];
                        const {competitions, seasons, locations} = data;
                        competitionsOptions = withSelectAllOptions(competitions?.map(item => ({value: item.id, key: item.id, label: item.name})));
                        seasonsOptions = withSelectAllOptions(seasons?.map(item => ({value: item.id, key: item.id, label: item.name})));
                        locationsOptions = withSelectAllOptions(locations?.map(item => ({value: item.id, key: item.id, label: item.name})));
                    }

                    return (
                        <div className="filter-search-container">
                            <Form onSubmit={this.handleSubmit} className="toolbar">
                                <Form.Row className="row form">
                                    <Col xl={"auto"} lg={3} xs={6} className="filter">
                                        <SelectButtons size="sm" options={selectButtonsOptions} onSelect={handleTableSelect}/>
                                    </Col>
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectFilter selected="true" loading={loading} error={error} type="sm" name="regions" placeholder="All Competitions Played" options={competitionsOptions}/>
                                    </Col>
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectSearch selected="true" loading={loading} error={error} type="sm" name="countries" placeholder="All Seasons" searchPlaceholder="Search Seasons" options={seasonsOptions}/>
                                    </Col>
                                    <Col xl={2} lg={3} xs={6} className="filter">
                                        <SelectSearch selected="true" loading={loading} error={error} type="sm" name="countries" placeholder="All Locations Played" searchPlaceholder="Search Conuntry" options={locationsOptions}/>
                                    </Col>
                                    <Col xl={3} lg={3} xs={6} className="ml-auto filter">
                                        <InputSearch size="sm"/>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </div>
                    );
                }}
            </Query>
        );
    };

    handleTableSelect = (event, option) => {
        this.setState({
            type: option.value,
        });
    };

    renderTable = () => {
        const {type} = this.state;

        return (
            <StatsAndVideosPerMatchDataTable type={type} onVideoClick={this.handleVideoClick} />
        );
    };

    /**
     * Handlers
     */
    handleVideoClick = (event, params) => {

    };
}


export default StatsAndVideosPerMatch;
